module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.4a51a7d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/font/AmwayIcons.woff?5v2gxx
// module id = mPot
// module chunks = 0